import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { Modal } from 'bootstrap';

import { Data2Service } from '../common/data2.service';
import { InfoboxService } from '../common/infobox/infobox.service';
import { SeasonFiltersComponent } from './season-filters/season-filters.component';
import { QuestionService } from '../common/question-dialog/question-dialog.service';

@Component({
	selector: 'app-season',
	templateUrl: './season.component.html',
	styleUrls: ['./season.component.css'],
})
export class SeasonComponent implements OnInit {
	loader = true;
	elements: Array<any> = [];
	showElements: Array<any> = [];
	showCheckboxes = false;
	filterValue: string;
	filters = {};
	settingsObject = {
		id: null,
		status: null,
		tourismEvents: null,
		profit: null,
		offerId: null,
		costs: null,
		plannedPayments: null,
		costsFixed: null,
		costsVariable: null,
		income: null,
		offerTermId: null,
		sell7days: null,
		sell14days: null,
		sell21days: null,
		sellmore21days: null,
		price7days: null,
		price14days: null,
		price21days: null,
		pricemore21days: null,
	};
	users: Array<any> = [];
	checksum: null;
	tourismEvents = [];
	statuses = [
		{
			id: '0',
			name: '0%',
		},
		{
			id: '25',
			name: '25%',
		},
		{
			id: '50',
			name: '50%',
		},
		{
			id: '75',
			name: '75%',
		},
		{
			id: '100',
			name: '100%',
		},
	];
	kinds = [
		{
			id: 'A',
			name: 'Samolotem',
		},
		{
			id: 'C',
			name: 'Autokrem',
		},
	];
	data = {};
	private settingsModal: Modal;
	private raportModal: Modal;
	private raportModalReportCancel: Modal;
	private filtersModal: Modal;
	private deleteModal: Modal;
	private readonly weekday = ['Niedziela', 'Poniedziałek', 'Wtorek', 'Środa', 'Czwartek', 'Piątek', 'Sobota'];

	constructor(
		private readonly api: Data2Service,
		private readonly infobox: InfoboxService,
		private readonly router: Router,
		private readonly route: ActivatedRoute,
		private readonly question: QuestionService,
	) {}

	ngOnInit(): void {
		this.settingsModal = new Modal(document.getElementById('settingsModal'));
		this.raportModal = new Modal(document.getElementById('raportModal'));
		this.raportModalReportCancel = new Modal(document.getElementById('raportModalReportCancel'));
		this.filtersModal = new Modal(document.getElementById('filtersModal'));
		this.deleteModal = new Modal(document.getElementById('deleteModal'));
		this.api.get('/users/', (result, error) => {
			this.users = result.data;
		});
	}

	private loadData() {
		this.loader = true;
		const parms: string = this.getChecked();
		this.api.get('/season/?' + parms, (result, error) => {
			result.data.forEach((obj) => {
				obj.departureFromFirstStop = this.dateFormat(obj.departureFromFirstStop);
				obj.departureFromFirstStopWeekday = this.getWeekday(obj.departureFromFirstStop);
				obj.accommodationTo = this.dateFormat(obj.accommodationTo);
				obj.accommodationToWeekday = this.getWeekday(obj.accommodationTo);
				obj.accommodationFrom = this.dateFormat(obj.accommodationFrom);
				obj.accommodationFromDestinationWeekday = this.getWeekday(obj.accommodationFrom);
				obj.arrivalToLastStop = this.dateFormat(obj.arrivalToLastStop);
				obj.arrivalToLastStopWeekday = this.getWeekday(obj.arrivalToLastStop);
				obj.class = this.classFromStatus(obj.status);
				obj.touristGuide = this.touristGuideParse(obj.toursitGuides);
			});
			this.elements = result.data;
			this.showElements = this.elements;
			this.loader = false;
		});
	}

	private touristGuideParse(touristGuides) {
		const result = [];
		touristGuides.forEach((touristGuides) => {
			if (!touristGuides) {
				return;
			}
			result.push(touristGuides.guide);
		});
		return result.join('; ');
	}

	private getWeekday(date) {
		const dateObj = new Date(date);
		return this.weekday[dateObj.getDay()];
	}

	private classFromStatus(status: string): string {
		switch (status) {
			case '100':
				return 'table-info';
			case '75':
				return 'table-primary';
			case '50':
				return 'table-light';
			case '25':
				return 'table-secondary';
			case '0':
				return 'table-danger';
		}
		return '';
	}

	private dateFormat(date: string): string {
		return date.split(' ')[0];
	}

	private getChecked(): string {
		let checked = '';
		const items = '';
		for (const key in this.filters) {
			switch (key) {
				default:
					if (this.filters[key]?.length) {
						checked += '&' + key + '=' + this.filters[key];
					}
					break;
			}
		}
		return checked.replace(/^&/, '');
	}

	settingsOpen(object) {
		this.settingsObject = object;
		this.settingsModal.show();
	}

	settingsSave() {
		this.settingsClose();
		this.loader = true;
		const season = this.elements.find((obj) => obj.id == this.settingsObject.id);
		season.status = this.settingsObject.status;
		season.class = this.classFromStatus(season.status);
		this.api.put('/season/' + season.id, season, (result, error) => {
			this.loader = false;
			if (error) {
				return;
			}
		});
	}

	errorClose() {
		this.loader = true;
		const season = this.elements.find((obj) => obj.id == this.settingsObject.id);
		season.show = '0';
		this.api.put('/season/' + season.id, season, (result, error) => {
			this.loader = false;
			this.loadData();
			if (error) {
				return;
			}
		});
		this.settingsModal.hide();
	}

	settingsClose() {
		this.settingsModal.hide();
	}

	filtersOpen() {
		new SeasonFiltersComponent(this.api, this.route, this.router).filtersOpen();
	}

	filtersSelected(data) {
		this.filters = data;
		this.loadData();
	}

	refreshFilter() {
		this.showElements = this.elements.filter((obj) => {
			const searchValue = this.filterValue.trim().toLowerCase();
			return Object.keys(obj).some((key) => {
				if (obj[key] == null) {
					return;
				}
				return obj[key].toString().toLowerCase().includes(searchValue);
			});
		});
	}

	setToMap(side: string): void {
		this.filterValue = '';
		this.refreshFilter();
		const checkedElements = this.showElements
			.filter((obj) => obj.checked == true)
			.map((o) => o.id)
			.join();
		if (!checkedElements || !checkedElements.length) {
			return;
		}
		this.loader = true;
		this.api.post('/tourismTimetable/', { seasons: checkedElements, side: side }, (result, error) => {
			this.loader = false;
			if (error?.error?.errorCode === 409) {
				this.mixTimetable(JSON.parse(error.error.error), side);
				return;
			}
			if (error) {
				return;
			}
			window.open('/tourism-map/' + result.data, '_blank').focus();
		});
	}

	private mixTimetable(content, side): void {
		const urls = content.map((obj) => {
			return (obj = `</br><a href="/tourism-map/${obj.timetable}" target="_blank">${obj.season}</a>`);
		});
		const subscribe = this.question
			.ask(
				`Dla wybranej pozycji:
        ${urls}
        </br>Został już utworzony rozkład jazdy, kontynuacja oznacza zresetowanie rozkładu dla powyższych wydarzeń. <b>Czy mimo to chcesz kontynuować</b>?`,
			)
			.subscribe((result) => {
				if (result.result) this.resetTimetables(content, side);
				subscribe.unsubscribe();
			});
	}

	private resetTimetables(content, side) {
		const removable = [];
		content.forEach((element) => {
			if (!removable.includes(element.timetable)) {
				this.reset(element.timetable);
				removable.push(element.timetable);
			}
		});
		this.setToMap(side);
	}

	private reset(timetableId) {
		this.api.command('/tourismTimetable/', { cmd: 'resetSeason', id: timetableId }, (result, error) => {
			if (error) {
				return;
			}
		});
	}

	submit() {
		const data = {
			cmd: 'seasonTouristEvents',
		};
		this.api.command('/season', data, (result, error) => {
			if (error) {
				return;
			}
		});
		this.raportModal.show();
	}
	reportCancel() {
		const data = {
			cmd: 'cancelBcs',
		};
		this.api.command('/season', data, (result, error) => {
			if (error) {
				return;
			}
		});
		this.raportModalReportCancel.show();
	}

	delete() {
		this.deleteModal.show();
	}
	deleteClose() {
		this.deleteModal.hide();
	}

	deleteSeason(checksum) {
		if (checksum != 81) {
			this.infobox.error('BŁĄÐ Licz na siebie');
			return;
		}
		this.errorClose();
		checksum = 0;
	}

	raportClose() {
		this.raportModal.hide();
	}
	raportModalReportCancelClose() {
		this.raportModalReportCancel.hide();
	}
}
